import { z } from 'zod';

// Single source of truth for the current published version of each policy.
// When you ship an updated Privacy Policy / Terms of Service, bump the matching
// version here and the application will re-prompt the user to accept the new
// version at next sign-in.
export const POLICY_KINDS = ['privacy_policy', 'terms_of_service'] as const;
export type PolicyKind = (typeof POLICY_KINDS)[number];

export const CURRENT_POLICY_VERSIONS: Record<PolicyKind, string> = {
  privacy_policy: '1.0',
  terms_of_service: '1.0', // not yet published; harmless placeholder
};

// Which policies must be accepted before the app is usable. (Terms of Service
// isn't published yet, so we only gate on the Privacy Policy for now.)
export const REQUIRED_POLICY_KINDS: PolicyKind[] = ['privacy_policy'];

export const acceptPolicyInputSchema = z.object({
  policyKind: z.enum(POLICY_KINDS),
  policyVersion: z.string().min(1).max(20),
});
export type AcceptPolicyInput = z.infer<typeof acceptPolicyInputSchema>;

export interface PolicyAcceptance {
  policyKind: PolicyKind;
  policyVersion: string;
  acceptedAt: string;
}

export interface PolicyAcceptanceStatus {
  acceptances: PolicyAcceptance[];
  /** Policies that are required but not yet accepted at the CURRENT version. */
  outstanding: { policyKind: PolicyKind; policyVersion: string }[];
}
